import { render, staticRenderFns } from "./otherOptionBox.vue?vue&type=template&id=55718925&scoped=true&"
import script from "./otherOptionBox.vue?vue&type=script&lang=js&"
export * from "./otherOptionBox.vue?vue&type=script&lang=js&"
import style0 from "./otherOptionBox.vue?vue&type=style&index=0&id=55718925&lang=scss&scoped=scoped&"
import style1 from "./otherOptionBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55718925",
  null
  
)

export default component.exports